export const getCurrentPosition = () => new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(position => resolve(position.coords), reject);
  })

  /*
    A partir de uma lista de posicao no mapa, essa funcao calcula um ponto central entre esses pontos
    para melhor centralizar o mapa.
  */
const getCentroid = (positions) => {
  const locales = positions.map(({ lat, lng }) => [lat, lng])
  const centroidList = locales.reduce((lat,lng) =>
  [lat[0] + lng[0]/locales.length, lat[1] + lng[1]/locales.length], [0,0])
  const [lat, lng] = centroidList
  return { lat, lng }
}

export const centerMyMap = (locales) => {
  if (locales.length === 0) {
    return null
  }
  if (locales.length === 1) {
    return locales[0]
  }
  return getCentroid(locales)
}



// WEBPACK FOOTER //
// ./src/components/TechnicianModal/components/TechnicianMap/utils/maps.js